import { createClient, type SupabaseClient } from '@supabase/supabase-js';

/**
 * Supabase client.
 *
 * The anon key is meant to be public and ships inside the bundle: Row Level
 * Security is what actually protects the data, not the secrecy of this key.
 * The service_role key must never appear here.
 *
 * Both values are optional at build time so the app still runs, entirely
 * offline and local-only, when no backend is configured — which is exactly
 * how it behaved before sync existed.
 */
const url = import.meta.env['VITE_SUPABASE_URL'] as string | undefined;
const anonKey = import.meta.env['VITE_SUPABASE_ANON_KEY'] as string | undefined;

export const isSyncConfigured = Boolean(url && anonKey);

export const supabase: SupabaseClient | null = isSyncConfigured
  ? createClient(url!, anonKey!, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        // The app has no URL-based auth callbacks; email OTP is verified
        // in-page, so there is nothing to detect in the address bar.
        detectSessionInUrl: false,
      },
    })
  : null;

/** Narrowing helper for the many call sites that need a configured client. */
export function requireSupabase(): SupabaseClient {
  if (!supabase) throw new Error('Supabase is not configured');
  return supabase;
}
